import { getMenu, saveMenuMe, delMenuMe } from "@/api/menu";

const menu = {
  state: {
    Menus: [],
    MenusMe: [],
    MenuNum: 0
  },
  mutations: {
    // 设置menu菜单
    SET_MENUS: (state, Menus) => {
      state.Menus = Menus
    },
    // 设置我的菜单
    SET_MENU_ME: (state, MenusMe) => {
      state.MenusMe = MenusMe
    },
    // 设置MenuNum
    SET_MENU_NUM: (state, MenuNum) => {
      state.MenuNum = MenuNum
    },
    // 保存MenuMe
    SAVE_MENU_ME: (state, menuId) => {
      for (var i = 0; i < state.Menus[state.MenuNum].childMenu.length; i++) { 
        for (var n = 0; n < state.Menus[state.MenuNum].childMenu[i].childMenu.length; n++) { 
          if(menuId == state.Menus[state.MenuNum].childMenu[i].childMenu[n].menuId && state.Menus[state.MenuNum].childMenu[i].childMenu[n].menuMe != '1'){
            state.Menus[state.MenuNum].childMenu[i].childMenu[n].menuMe = '1'
            state.MenusMe.push(state.Menus[state.MenuNum].childMenu[i].childMenu[n])
            break
          }
        }  
      }
    },
    // 删除MenuMe
    DEL_MENU_ME: (state, menuId) => {
      for (var i = 0; i < state.MenusMe.length; i++) { 
        if(menuId == state.MenusMe[i].menuId){
          state.MenusMe.splice(i,1)
          break
        }
      }
      for (var i = 0; i < state.Menus[state.MenuNum].childMenu.length; i++) { 
        for (var n = 0; n < state.Menus[state.MenuNum].childMenu[i].childMenu.length; n++) { 
          if(menuId == state.Menus[state.MenuNum].childMenu[i].childMenu[n].menuId && state.Menus[state.MenuNum].childMenu[i].childMenu[n].menuMe == '1'){
            state.Menus[state.MenuNum].childMenu[i].childMenu[n].menuMe = '0'
            break
          }
        }  
      }
    }
  },
  actions: {
    // 设置menuMapping
    getMenus({ commit }) {
      getMenu().then(res => {
        const Menus = res.data.menulist
        const MenusMe = res.data.menulistme
        commit('SET_MENUS', Menus)
        commit('SET_MENU_ME', MenusMe)
      })
      .catch(error => {
        reject(error)
      });
    },
    saveMenuMe({ commit }, menuId) {
      commit('SAVE_MENU_ME', menuId)
      saveMenuMe(menuId).then(res => {  
      })
      .catch(error => {
        reject(error)
      });
    },
    delMenuMe({ commit }, menuId) { 
      commit('DEL_MENU_ME', menuId)
      delMenuMe(menuId).then(res => {  
      })
      .catch(error => {
        reject(error)
      });
    }
  }
}


export default menu



// WEBPACK FOOTER //
// ./src/store/modules/menu.js